import React, { useState } from "react";
import { Modal, Button, notification, Form } from "antd";
import { EditOutlined } from "@ant-design/icons";
import useRoleCheck from "utilities/hooks/roleCheck";

import EditForm from "./EditForm";
import EquipmentDisplay from "./EquipmentDisplay";
import axiosInstance from "utilities/axios";

function EquipmentModal({ equipment, open, onClose, onChange }) {
  const { hasPermission } = useRoleCheck();
  const [form] = Form.useForm();

  const [editMode, setEditMode] = useState(false);

  const EditFooter = [
    // <Button
    // 	key='training'
    // 	onClick={() => {
    // 		notification.info({
    // 			message: 'Training',
    // 			description: 'Training feature coming soon',
    // 		});
    // 	}}
    // 	type
    // >
    // 	Edit Training Email
    // </Button>,
    <Button
      key="cancel"
      onClick={() => {
        setEditMode(false);
        form.resetFields();
      }}
    >
      Cancel
    </Button>,
    <Button
      key="save"
      type="primary"
      onClick={() => {
        form
          .validateFields()
          .then((values) => {
            axiosInstance
              .put(`/equipment/${equipment.id}`, values)
              .then(() => {
                notification.success({
                  message: "Success",
                  description: "Equipment updated successfully",
                });
                onChange();
                onClose();
              })
              .catch((error) => {
                console.log(error);
                notification.error({
                  message: "Error",
                  description: error.message,
                });
              });
          })
          .catch((error) => {
            console.log(error);
            notification.error({
              message: "Error",
              description: error.message,
            });
          });
      }}
    >
      Save
    </Button>,
  ];

  const CreateFooter = [
    <Button key="cancel" onClick={onClose}>
      Cancel
    </Button>,
    <Button
      key="save"
      type="primary"
      onClick={() => {
        form
          .validateFields()
          .then((values) => {
            axiosInstance
              .post(`/equipment`, values)
              .then(() => {
                notification.success({
                  message: "Success",
                  description: "Equipment created successfully",
                });
                onChange();
                setEditMode(false);
              })
              .catch((error) => {
                console.log(error);
                notification.error({
                  message: "Error",
                  description: error.message,
                });
              });
          })
          .catch((error) => {
            console.log(error);
            notification.error({
              message: "Error",
              description: error.message,
            });
          });
      }}
    >
      Create
    </Button>,
  ];

  const DisplayFooter = [
    <Button key="close" onClick={onClose}>
      Close
    </Button>,
    hasPermission(["Audiology"], [], [], false) && (
      <Button key="edit" type="primary" onClick={() => setEditMode(true)}>
        <EditOutlined />
        Edit
      </Button>
    ),
  ];

  return (
    <Modal
      title={
        editMode
          ? "Update Equipment"
          : equipment
          ? "Equipment Details"
          : "Add Equipment"
      }
      afterClose={() => {
        form.resetFields();
        setEditMode(false);
      }}
      open={open}
      onCancel={onClose}
      //footer is either "Close", "Save/Cancel" or "Create/Cancel" depending on the mode
      footer={editMode ? EditFooter : equipment ? DisplayFooter : CreateFooter}
    >
      {editMode ? (
        <EditForm equipment={equipment} form={form} />
      ) : equipment ? (
        <EquipmentDisplay equipment={equipment} />
      ) : (
        <EditForm form={form} />
      )}
    </Modal>
  );
}

export default EquipmentModal;
